import ClothingCustomizationPage from "../components/Storefront/Clothing/CustomClothing";
import { useEffect } from "react";

const CustomClothingPage = () => {

  useEffect(() => {
    document.title = "Clothing Customization";
  }, []);

  return (
    <div>
      <ClothingCustomizationPage />
    </div>
  );
};

export default CustomClothingPage;
